import script from "./DropdownMenuItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./DropdownMenuItem.vue?vue&type=script&lang=ts&setup=true"

import "./DropdownMenuItem.vue?vue&type=style&index=0&id=773fd196&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-773fd196"]])

export default __exports__